import moment from 'moment';
import _ from 'lodash';
import jsPDF from 'jspdf';
import 'jspdf-autotable';

import timeEntryUpdatesController from "./modals/time-entry-updates/time-entry-updates.controller";
import timeEntryUpdatesTemplate from "./modals/time-entry-updates/time-entry-updates.html";
import outOfOfficeModal from './modals/out-of-office/out-of-office.component'
import TaskSelectionModal from "./modals/task-selection/task-selection.component";
import SubmitTimesheetModal from "./modals/submit-timesheet/submit-timesheet.component";
import TimeEntryUpdatesModal from "./modals/time-entry-updates/time-entry-updates.component";
import leaveService from './services/leave.service';



class TimesheetController {
  constructor(AuthenticationService, TimesheetService, $rootScope, $scope,
    $uibModal, SettingsService, TimesheetMetricsService, $state, LeaveService,
    $http, $timeout, toastr, toastrConfig, $window) {
    "ngInject";
    this.name = 'timesheet';
    this.$rootScope = $rootScope;
    this.$scope = $scope;
    this.$timeout = $timeout;
    this.toastr = toastr;
    this.toastrConfig = toastrConfig;
    this.authenticationService = AuthenticationService;
    this.timesheetService = TimesheetService;
    this.settingsService = SettingsService;
    this.modal = $uibModal;
    this.selectedDate = moment();
    this.timesheetLocked = false
    this.ptoService = LeaveService;
    this.http = $http;
    this.state = $state;
    this.outOfOffice = null
    this.outOfOfficeInfo = {}
    this.timesheetLoaded = false;
    this.dateRangeView = 'all';
    this.dateRangeOffset = 0; // Track current week/day offset for navigation
    this.$window = $window;
    
    // Set initial view based on screen width
    this.updateViewBasedOnWidth();
    
    // Listen for window resize events
    const resizeHandler = () => {
      this.$timeout(() => {
        this.updateViewBasedOnWidth();
      });
    };
    
    angular.element(this.$window).on('resize', resizeHandler);
    
    // Clean up listener on scope destroy
    $scope.$on('$destroy', () => {
      angular.element(this.$window).off('resize', resizeHandler);
    });

    // Store the original toastr timeout configuration for restoration
    this.originalToastrTimeOut = toastrConfig.timeOut;
    this.originalToastrExtendedTimeOut = toastrConfig.extendedTimeOut;
    
    // Set toastr timeout to 4 seconds for this page
    toastrConfig.timeOut = 4000;
    toastrConfig.extendedTimeOut = 4000;

    this.loadTs().then(() => {
      this.timesheetLoaded = true;
    }).catch((error) => {
      this.toastr.error("There was an error loading your timesheet:", "Timesheet Loading Error");
      console.error('Failed to load timesheet:', error);
    });

    this.http.get(this.$rootScope.apiHost+"/api/users/me/out-of-office", {withCredentials: true}).then((response) => {
      this.outOfOffice = response.data
    })

    this.submitButtonMessageMap = {
      'REJECTED': 'Re-Submit',
      'SUBMITTED': 'I made a mistake',
      'APPROVED': 'I made a mistake',
      'REJECTION_REQUESTED': 'Waiting for approver to reject',
      'OPEN': 'Sign and Submit'
    }

    this.submitButtonActionMap = {
      'REJECTED': 'resubmit',
      'APPROVED': 'request-rejection',
      'SUBMITTED': 'request-rejection',
      'OPEN': 'submit'
    }

    this.lockedStatus = ['REJECTION_REQUESTED', 'APPROVED'];

    $scope.$watch(() => this.outOfOffice, (newVal) => {
      if (newVal && newVal.id) {
        const start = moment(newVal.startDate).startOf('day')
        const end = moment(newVal.endDate).startOf('day')
        const today = moment().startOf('day')
        const oooNumDays = moment.duration(end.diff(start)).as('days')
        // Check if current date is between start and end dates (inclusive)
        const isOutOfOffice = today.isSameOrAfter(start) && today.isSameOrBefore(end)

        const durationUntil = isOutOfOffice
          ? moment.duration(end.diff(moment().local())).humanize() + ' remaining' // until end
          : moment.duration(start.diff(moment().local())).humanize(true) // until start

        this.outOfOfficeInfo = {
          start: start.local().format('M/D ddd'),
          end: end.local().format('M/D ddd'),
          startDate: start.toDate(), // Store date object for date filter
          endDate: end.toDate(), // Store date object for date filter
          numDaysOutOfOffice: oooNumDays + (oooNumDays > 1 ? ' days' : ' day') ,
          isOutOfOffice,
          durationUntil,
          autoSubmit: newVal.autoSubmitTimesheet,
        }
      } else {
        this.outOfOfficeInfo = {}
      }

    }, true)

    // All expression scenarios when timesheet should be locked
    const timesheetLockProperties = [
      () => !!this.outOfOfficeInfo.isOutOfOffice,
      () => this.lockedStatus.indexOf(this.timesheetService.currentTimesheet.status.toUpperCase()) > -1,
    ]

    $scope.$watchGroup(timesheetLockProperties, (newVals) => {
      const isOutOfOffice = newVals[0]
      const lockedStatus = newVals[1]
      this.timesheetLocked = isOutOfOffice || lockedStatus
    })

    // Restore toastr configuration when leaving the page
    $scope.$on('$destroy', () => {
      this.restoreToastrConfig();
    });
  }

  /**
   * Restore the original toastr configuration
   */
  restoreToastrConfig() {
    if (this.originalToastrTimeOut !== undefined) {
      this.toastrConfig.timeOut = this.originalToastrTimeOut;
    }
    if (this.originalToastrExtendedTimeOut !== undefined) {
      this.toastrConfig.extendedTimeOut = this.originalToastrExtendedTimeOut;
    }
  }

  showLeaveChargeCode(leaveChargeCode) {
    if (leaveChargeCode.name === 'PTO') {
        return this.authenticationService.user.trackLeave && this.hasTimeEntriesWithHours()
    }

    return true
  }

  async loadTs() {
    const ts = await this.timesheetService.loadTimesheet(this.selectedDate.toISOString());
    this.originalLoadEndDate = ts.endDate;
    return ts;
  }

  onDateSelected(selectedDate) {
    this.timesheetService.loadTimesheet(selectedDate).then(() => {
      console.log('New timesheet loaded');
    });
  }

  scrollLeft() {
    const newDate = moment(this.timesheetService.currentTimesheet.startDate).subtract(1,'days').toISOString();
    this.timesheetService.loadTimesheet(newDate).then(() => {
      console.log('Previous timesheet loaded');
    });
  }

  scrollRight() {
    const newDate = moment(this.timesheetService.currentTimesheet.endDate).add(1,'days').toISOString();
    this.timesheetService.loadTimesheet(newDate).then(() => {
      console.log('Next timesheet loaded');
    });
  }

  disableScrollRight() {
    return moment().isBetween(moment(this.timesheetService.currentTimesheet.startDate), moment(this.timesheetService.currentTimesheet.endDate));
  }

  isSaveButtonDisabled() {
    return this.timesheetLocked || !this.isTimesheetDirty();
  }

  isTimesheetDirty() {
    return this.timesheetService.currentTimesheet.dataDirty;
  }

  hasLwopEntriesWithHours() {
    return this.timesheetService.currentTimesheet.timeEntries
      .some(timeEntry => timeEntry.chargeCode.id === CHARGECODE_ID_LWOP && timeEntry.hours && timeEntry.hours > 0)
  }

  hasNonLeaveTimeEntries() {
    let timeEntries = this.timesheetService.currentTimesheet.timeEntries;
    let nonLeaveEntries = _.filter(timeEntries, function(o) { return !o.chargeCode.leaveType; });
    return nonLeaveEntries.length > 0;
  }

  hasTimeEntriesWithHours() {
    return this.timesheetService.currentTimesheet.timeEntries.some(timeEntry => timeEntry.hours > 0)
  }

  hasTimeEntries() {
    return Object.keys(this.timesheetService.currentTimesheet.timeEntries).length > 0;
  }

  isSubmitButtonDisabled() {
    let rejReq = this.timesheetService.currentTimesheet.status.toUpperCase() === 'REJECTION_REQUESTED';
    //user is not hourly
    if(this.authenticationService.user) {
      let fullTimeEmployee =  this.authenticationService.user.userType === 'fullTime';
      let trackLeave =  this.authenticationService.user.trackLeave;

      if(fullTimeEmployee && trackLeave && (this.getTotalTime() !== this.timesheetService.getTotalHoursForTimesheet())) {
         return true;
      }
    }

    return rejReq || !this.hasTimeEntries() || this.isTimesheetDirty();
  }

  getTimesheetSubmitButtonMessage() {
    return this.submitButtonMessageMap[this.timesheetService.currentTimesheet.status.toUpperCase()];
  }

  getTimesheetSubmitAction() {
    return this.submitButtonActionMap[this.timesheetService.currentTimesheet.status.toUpperCase()];
  }

  isSelectedDate(timeEntry) {
    return angular.equals(this.selectedTimeEntry, timeEntry);
  }

  isWeekend(dateString) {
    let date = moment(dateString);
    return (date.weekday() === 0 || date.weekday() == 6);
  }

  selectEntryByDate(date) {
    this.selectedDate = date;
    this.$rootScope.$emit('dateselected', date);
  }

  getDisplayedDateRange() {
    if (!this.timesheetService.currentTimesheet || !this.timesheetService.currentTimesheet.dateRange) {
      return [];
    }

    const dateRange = this.timesheetService.currentTimesheet.dateRange;
    
    if (this.dateRangeView === 'all') {
      return dateRange;
    }

    if (this.dateRangeView === 'week') {
      // Return 7 days starting from the offset week
      const startIndex = this.dateRangeOffset * 7;
      const endIndex = Math.min(startIndex + 7, dateRange.length);
      return dateRange.slice(startIndex, endIndex);
    }

    if (this.dateRangeView === 'day') {
      // Return the day at the current offset
      if (this.dateRangeOffset >= 0 && this.dateRangeOffset < dateRange.length) {
        return [dateRange[this.dateRangeOffset]];
      }
      return [];
    }

    return dateRange;
  }

  updateViewBasedOnWidth() {
    const width = this.$window.innerWidth;
    let newView = 'all';
    
    if (width <= 750) {
      newView = 'day';
    } else if (width <= 1000) {
      newView = 'week';
    } else {
      newView = 'all';
    }
    
    // Only update if view changed
    if (this.dateRangeView !== newView) {
      this.dateRangeView = newView;
      this.dateRangeOffset = 0; // Reset offset when view changes
    }
  }

  onDateRangeViewChange() {
    // Reset offset when changing view type
    this.dateRangeOffset = 0;
  }

  canNavigatePrevious() {
    if (this.dateRangeView === 'all') {
      return false;
    }
    return this.dateRangeOffset > 0;
  }

  canNavigateNext() {
    if (!this.timesheetService.currentTimesheet || !this.timesheetService.currentTimesheet.dateRange) {
      return false;
    }
    
    if (this.dateRangeView === 'all') {
      return false;
    }

    const dateRange = this.timesheetService.currentTimesheet.dateRange;
    
    if (this.dateRangeView === 'week') {
      const nextStartIndex = (this.dateRangeOffset + 1) * 7;
      return nextStartIndex < dateRange.length;
    }

    if (this.dateRangeView === 'day') {
      return this.dateRangeOffset < dateRange.length - 1;
    }

    return false;
  }

  navigatePrevious() {
    if (this.canNavigatePrevious()) {
      this.dateRangeOffset--;
    }
  }

  navigateNext() {
    if (this.canNavigateNext()) {
      this.dateRangeOffset++;
    }
  }

  getFilteredTimeEntriesForChargeCode(chargeCodeName) {
    if (!this.timesheetService.currentTimesheet) {
      return [];
    }
    
    const displayedDates = this.getDisplayedDateRange();
    const allTimeEntries = this.timesheetService.currentTimesheet.timeEntriesForChargeCode(chargeCodeName);
    
    // Create a map of time entries by date for quick lookup
    const entriesByDate = {};
    allTimeEntries.forEach(timeEntry => {
      const entryDate = moment(timeEntry.date).format('YYYY-MM-DD');
      entriesByDate[entryDate] = timeEntry;
    });
    
    // Return time entries in the same order as displayed dates
    // If no entry exists for a date, create a placeholder entry
    return displayedDates.map(date => {
      const dateKey = date.format('YYYY-MM-DD');
      if (entriesByDate[dateKey]) {
        return entriesByDate[dateKey];
      }
      // Create a placeholder entry for dates without entries
      // This ensures the columns align properly
      const chargeCode = this.timesheetService.currentTimesheet.availableChargeCodes.find(cc => cc.name === chargeCodeName);
      if (chargeCode) {
        return this.timesheetService.currentTimesheet.getTimeEntry(chargeCode, date);
      }
      return null;
    }).filter(entry => entry !== null);
  }

  getLeaveChargeCodes() {
    return this.timesheetService.getLeaveChargeCodes();
  }

  getNonLeaveChargeCodes() {
    return this.timesheetService.getNonLeaveChargeCodes();
  }

  isChargeCodeExpired(chargeCode) {
    if (!chargeCode || !chargeCode.expirationDate) {
      return false;
    }

    // Mark the whole row expired only if the charge code expired before this
    // timesheet period started. Mid-period expirations are handled per cell by
    // time-entry-input (_isActiveChargeCode), so days on/before expiration stay editable.
    let periodStart = moment().startOf('day');
    if (this.timesheetService.currentTimesheet && this.timesheetService.currentTimesheet.startDate) {
      periodStart = moment(this.timesheetService.currentTimesheet.startDate).startOf('day');
    }

    const expirationDate = moment(chargeCode.expirationDate).startOf('day');
    return expirationDate.isBefore(periodStart);
  }

  getChargeCodeExpirationDate(chargeCode) {
    if (!chargeCode || !chargeCode.expirationDate) {
      return null;
    }
    return moment(chargeCode.expirationDate).format('MMM DD, YYYY');
  }

  getUserLeaveChargeCodes() {
    return this.authenticationService.user
      ? this.authenticationService.user.availableChargeCodes.filter((cc) => cc.leaveType)
      : []
  }

  deactivateOutOfOffice() {
    this.http.post(`${this.$rootScope.apiHost}/api/users/me/out-of-office/deactivate`, {}, {withCredentials: true}).then(() => { this.outOfOffice = {} });
  }

  getTotalChargeCodeTime(chargeCodeName) {
    let total = 0;

    if(chargeCodeName) {
      let p = this.timesheetService.getTimeEntriesForChargeCode(chargeCodeName);
      for(let i=0; i < p.length; i++) {
        if(p[i].hours) {
          total = total + p[i].hours;
        }
      }
    }

    return total;
  }


  save() {
    let today = moment().format('YYYY-MM-DD');
    let timeEntriesThatNeedReasons = [];

    // Auto-balance leave for empty time entries with dates before today
    for(let i = 0; i < this.timesheetService.currentTimesheet.timeEntries.length; i++){
      let timeEntry = this.timesheetService.currentTimesheet.timeEntries[i];
      
      if(this.authenticationService.user.trackLeave) {
        // Check if time entry is empty (no hours) and date is before today
        if(timeEntry && timeEntry.date && (!timeEntry.hours || timeEntry.hours === 0)) {
          if(moment(timeEntry.date).isBefore(moment(today))) {
            this.ptoService.autoBalanceLeave(timeEntry);
          }
        }
     }
    }

    for(let i = 0; i < this.timesheetService.currentTimesheet.timeEntries.length; i++){
      if(this.settingsService.isDcaaEnabled()) {
        let timeEntry = this.timesheetService.currentTimesheet.timeEntries[i];

        let entryDate = timeEntry.date;
        if(timeEntry.date) {
          entryDate = entryDate.format('YYYY-MM-DD');
        }

        if (timeEntry.mode > 0 && moment(entryDate).isBefore(moment(today))) {
          if(timeEntry.mode === 1) {
            timeEntry.type = 'new';
          } else if(timeEntry.mode === 2) {
            timeEntry.type = 'change';
          } else if(timeEntry.mode === 3) {
            timeEntry.type = 'delete';
          }

          if(!timeEntry.chargeCode.leaveType) {
            timeEntriesThatNeedReasons.push(timeEntry);
          }
        }
      }
    }

    if(timeEntriesThatNeedReasons.length > 0) {
        let modalInstance = this.showRequireReasonsDialog(timeEntriesThatNeedReasons);
        modalInstance.result.then(() => {
          this.saveTimesheet();
        }, () => { });
    } else {
      this.saveTimesheet();
    }

  }

  saveTimesheet() {
    this.timesheetService.saveTimesheet('save').then((response) => {
      this.timesheetService.loadTimesheet(this.timesheetService.currentTimesheet.startDate, this.timesheetService.currentTimesheet.id);
      this.ptoService.refreshPto();
      this.toastr.success("Timesheet Saved!", "Timesheet Saved");
    }, (response) => {
      this.toastr.error("There was an error saving your timesheet", "Timesheet Save Error");
    });
  }

  getTotalTime() {
    const entries = this.timesheetService.currentTimesheet.timeEntries;
    const total = entries.reduce((sum, entry) => {
      return sum + (entry.hours || 0);
    }, 0);

    return window.Utilities.roundToTwoDecimals(total);
  }

  changeTimesheetStatus(status) {
    if(status === 'submit' || status === 'resubmit') {
      if(this.authenticationService.user.trackLeave === true && this.getTotalTime() !== this.timesheetService.getTotalHoursForTimesheet()) {
          this.showRequiredHoursDialog();
          return;
      }
    }

    let modalInstance = this.modal.open(SubmitTimesheetModal);
    modalInstance.status = status;

    modalInstance.updateStatus = () => {
      this.timesheetService.saveTimesheet(status).then(
        (response) => {
          this.timesheetService.loadTimesheet(this.timesheetService.currentTimesheet.startDate);
          this.toastr.success("Timesheet Updated!", "Timesheet Updated");
          modalInstance.close();
        }, (response) => {
          this.toastr.error("Error updating timesheet.", "Timesheet Update Error");
        });
    }

    modalInstance.cancel = () => {
      modalInstance.dismiss();
    }

    modalInstance.result.then(() => {}, (res) => {});
  }


//========================== MODALS =========================================//
  showChargeCodeDialog() {
    let modalInstance = this.modal.open(TaskSelectionModal);

    modalInstance.addChargeCode = (chargeCode) => {
      this.timesheetService.addChargeCodeToTimesheet(chargeCode);
      this.toastr.success("Task Added to Timesheet!", "Task Added");
      modalInstance.dismiss();
    };

    modalInstance.requestTask = (requestText) => {
      this.http.post(`${this.baseUrl}taskRequest`,requestText, { withCredentials: true }).then((response) => {
        modalInstance.close();
      });
    }

    modalInstance.chargeCodeAlreadyAdded = (chargeCode) => {
      return this.timesheetService.hasChargeCode(chargeCode.name);
    }

    modalInstance.result.then(() => {}, (res) => {});
  }

  showRequireReasonsDialog(timeEntriesThatNeedReasons) {
    const modalInstance = this.modal.open(TimeEntryUpdatesModal);
    modalInstance.timeEntriesThatNeedReasons = timeEntriesThatNeedReasons;
    return modalInstance;
  }

  showRequiredHoursDialog(status) {
    let modalInstance = this.modal.open({
      template: modalTemplate,
      animation: true,
      windowClass: 'modal-test',
      windowTopClass: 'modal-test',
      controller: ['$scope', '$uibModalInstance', function ($scope, $uibModalInstance) {
        "ngInject";
      }]
    }).result.then(function () {}, function(res){}); // Adding .then() removes backdrop click error.

    return modalInstance;
  }



  outOfOfficeOptions() {
    const modalInstance = this.modal.open(outOfOfficeModal)
    modalInstance.leaveChargeCodes = this.getUserLeaveChargeCodes()
    modalInstance.outOfOffice = this.outOfOffice

    modalInstance.success = (outOfOffice) => {
      console.log('success!', outOfOffice)
      this.outOfOffice = outOfOffice
      modalInstance.dismiss()
    }

    modalInstance.cancel = () => modalInstance.dismiss()
  }

  /**
   * Load image from URL with authentication and convert to data URL
   * @param {string} url - Image URL
   * @returns {Promise<string>} - Data URL of the image
   */
  async loadImageAsDataUrl(url) {
    try {
      const response = await this.http.get(url, {
        responseType: 'arraybuffer',
        withCredentials: true,
        headers: {
          'Accept': 'image/*'
        }
      });
      
      // Convert arraybuffer to blob, then to data URL
      let contentType = 'image/png';
      if (response.headers) {
        contentType = response.headers('content-type') || response.headers('Content-Type') || 'image/png';
      }
      const blob = new Blob([response.data], { type: contentType });
      
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (error) {
      console.warn('Could not load image:', url, error);
      return null;
    }
  }

  /**
   * Export timesheet to PDF
   */
  async exportToPdf() {
    try {
      const doc = new jsPDF('l', 'mm', 'a4'); // Landscape orientation
      const timesheet = this.timesheetService.currentTimesheet;
      const user = this.authenticationService.user;
      
      // Header information
      const pageWidth = doc.internal.pageSize.getWidth();
      const pageHeight = doc.internal.pageSize.getHeight();
      let yPos = 15;
      
      // Title
      doc.setFontSize(18);
      doc.setFont(undefined, 'bold');
      doc.text('Timesheet', pageWidth / 2, yPos, { align: 'center' });
      yPos += 10;
      
      // User information
      doc.setFontSize(11);
      doc.setFont(undefined, 'normal');
      const userName = user.fullName || `${user.firstName} ${user.lastName}`;
      doc.text(`Employee: ${userName}`, 15, yPos);
      doc.text(`Period: ${moment(timesheet.startDate).format('MMM DD, YYYY')} - ${moment(timesheet.endDate).format('MMM DD, YYYY')}`, pageWidth - 15, yPos, { align: 'right' });
      yPos += 7;
      
      // Status
      doc.text(`Status: ${timesheet.status}`, 15, yPos);
      if (timesheet.submitDate) {
        doc.text(`Submitted: ${moment(timesheet.submitDate).format('MMM DD, YYYY')}`, pageWidth - 15, yPos, { align: 'right' });
      }
      yPos += 10;
      
      // Summary Data Box (similar to summary-data component)
      const statusMap = {
        'REJECTED': 'Rejected',
        'SUBMITTED': 'Submitted',
        'APPROVED': 'Approved',
        'REJECTION_REQUESTED': 'Rejection Requested',
        'OPEN': 'Open'
      };
      
      const status = statusMap[timesheet.status] || timesheet.status;
      const periodHours = this.timesheetService.getTotalHoursForTimesheet();
      const weekends = this.timesheetService.getTotalWeekends();
      const holidays = this.timesheetService.getHolidays();
      
      // Create summary boxes - compact size
      const boxWidth = 35; // Reduced width for compact boxes
      const boxHeight = 20; // Reduced height
      const boxStartX = 15;
      const boxSpacing = boxWidth + 8; // Reduced spacing
      
      // Status Box (Blue) - #3498db
      doc.setFillColor(52, 152, 219); // RGB for #3498db
      doc.rect(boxStartX, yPos, boxWidth, boxHeight, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(8);
      doc.setFont(undefined, 'bold');
      doc.text('Status', boxStartX + boxWidth / 2, yPos + 6, { align: 'center' });
      doc.setFontSize(9);
      doc.text(status, boxStartX + boxWidth / 2, yPos + 13, { align: 'center' });
      
      // Period Hours Box (Orange) - #e67e22
      doc.setFillColor(230, 126, 34); // RGB for #e67e22
      doc.rect(boxStartX + boxSpacing, yPos, boxWidth, boxHeight, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(8);
      doc.setFont(undefined, 'bold');
      doc.text('Period', boxStartX + boxSpacing + boxWidth / 2, yPos + 6, { align: 'center' });
      doc.setFontSize(9);
      // Truncate text if too long
      const periodText = periodHours.toString().length > 6 ? periodHours.toFixed(1) : `${periodHours} Hrs`;
      doc.text(periodText, boxStartX + boxSpacing + boxWidth / 2, yPos + 13, { align: 'center' });
      
      // Weekends Box (Green) - #62cb31
      doc.setFillColor(98, 203, 49); // RGB for #62cb31
      doc.rect(boxStartX + boxSpacing * 2, yPos, boxWidth, boxHeight, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(8);
      doc.setFont(undefined, 'bold');
      doc.text('Weekends', boxStartX + boxSpacing * 2 + boxWidth / 2, yPos + 6, { align: 'center' });
      doc.setFontSize(9);
      doc.text(weekends !== undefined && weekends !== null ? weekends.toString() : '', boxStartX + boxSpacing * 2 + boxWidth / 2, yPos + 13, { align: 'center' });
      
      // Holidays Box (Violet/Purple) - #9b59b6
      doc.setFillColor(155, 89, 182); // RGB for #9b59b6
      doc.rect(boxStartX + boxSpacing * 3, yPos, boxWidth, boxHeight, 'F');
      doc.setTextColor(255, 255, 255);
      doc.setFontSize(8);
      doc.setFont(undefined, 'bold');
      doc.text('Holidays', boxStartX + boxSpacing * 3 + boxWidth / 2, yPos + 6, { align: 'center' });
      doc.setFontSize(9);
      doc.text(holidays !== undefined && holidays !== null && holidays >= 0 ? holidays.toString() : '', boxStartX + boxSpacing * 3 + boxWidth / 2, yPos + 13, { align: 'center' });
      
      // Reset text color to black for rest of document
      doc.setTextColor(0, 0, 0);
      yPos += boxHeight + 8;
      
      // Prepare table data - Work Entries header (no Description column)
      const workDateHeaders = ['Work Entries'];
      timesheet.dateRange.forEach(date => {
        // Format: Day of week abbreviation + Month Day (e.g., "Mon 1", "Tue 2")
        workDateHeaders.push(moment(date).format('ddd M/D'));
      });
      workDateHeaders.push('Total');
      
      // Prepare table data - Leave Entries header (no Description column)
      const leaveDateHeaders = ['Leave Entries'];
      timesheet.dateRange.forEach(date => {
        // Format: Day of week abbreviation + Month Day (e.g., "Mon 1", "Tue 2")
        leaveDateHeaders.push(moment(date).format('ddd M/D'));
      });
      leaveDateHeaders.push('Total');
      
      // Work Entries (Non-Leave)
      const workChargeCodes = this.getNonLeaveChargeCodes();
      const workRows = [];
      
      workChargeCodes.forEach(chargeCode => {
        const row = [chargeCode.name];
        
        let total = 0;
        timesheet.dateRange.forEach(date => {
          const dateStr = moment(date).format('YYYY-MM-DD');
          const entry = timesheet.timeEntriesForChargeCode(chargeCode.name).find(te => {
            const entryDateStr = moment(te.date).format('YYYY-MM-DD');
            return entryDateStr === dateStr;
          });
          const hours = entry && entry.hours ? entry.hours : 0;
          row.push(hours > 0 ? hours.toFixed(2) : '');
          total += hours;
        });
        row.push(total > 0 ? total.toFixed(2) : '');
        workRows.push(row);
      });
      
      // Leave Entries
      const leaveChargeCodes = this.getLeaveChargeCodes();
      const leaveRows = [];
      
      leaveChargeCodes.forEach(chargeCode => {
        if (this.showLeaveChargeCode(chargeCode)) {
          const row = [chargeCode.name];
          
          let total = 0;
          timesheet.dateRange.forEach(date => {
            const dateStr = moment(date).format('YYYY-MM-DD');
            const entry = timesheet.timeEntriesForChargeCode(chargeCode.name).find(te => {
              const entryDateStr = moment(te.date).format('YYYY-MM-DD');
              return entryDateStr === dateStr;
            });
            const hours = entry && entry.hours ? entry.hours : 0;
            row.push(hours > 0 ? hours.toFixed(2) : '');
            total += hours;
          });
          row.push(total > 0 ? total.toFixed(2) : '');
          leaveRows.push(row);
        }
      });
      
      // Totals row (no Description column)
      const totalsRow = ['Timesheet Totals'];
      let grandTotal = 0;
      timesheet.dateRange.forEach(date => {
        const dailyTotal = this.timesheetService.getDailyTotal(date);
        totalsRow.push(dailyTotal > 0 ? dailyTotal.toFixed(2) : '');
        grandTotal += dailyTotal;
      });
      totalsRow.push(grandTotal.toFixed(2));
      
      // Add work entries table
      if (workRows.length > 0) {
        doc.autoTable({
          startY: yPos,
          head: [workDateHeaders],
          body: workRows,
          theme: 'striped',
          headStyles: { fillColor: [52, 73, 94], textColor: 255, fontStyle: 'bold' },
          styles: { fontSize: 8, cellPadding: 2 },
          columnStyles: {
            0: { cellWidth: 50 },
            [workDateHeaders.length - 1]: { fontStyle: 'bold' }
          },
          margin: { left: 15, right: 15 }
        });
        yPos = doc.lastAutoTable.finalY + 5;
      }
      
      // Add leave entries table (no header text, just the table)
      if (leaveRows.length > 0) {
        doc.autoTable({
          startY: yPos,
          head: [leaveDateHeaders],
          body: leaveRows,
          theme: 'striped',
          headStyles: { fillColor: [52, 73, 94], textColor: 255, fontStyle: 'bold' },
          styles: { fontSize: 8, cellPadding: 2 },
          columnStyles: {
            0: { cellWidth: 50 },
            [leaveDateHeaders.length - 1]: { fontStyle: 'bold' }
          },
          margin: { left: 15, right: 15 }
        });
        yPos = doc.lastAutoTable.finalY + 5;
      }
      
      // Add totals row - match header styling exactly (same blue background)
      // Create column styles for all columns to ensure blue background
      // Use workDateHeaders length since both tables have same structure (just different first column header)
      const totalsColumnStyles = {
        0: { 
          cellWidth: 50, 
          halign: 'left',
          fillColor: [52, 73, 94],
          textColor: 255,
          fontStyle: 'bold'
        }
      };
      
      // Add styles for all date columns and total column
      // Both headers have the same length (Work Entries/Leave Entries + dates + Total)
      const headerLength = workDateHeaders.length || leaveDateHeaders.length;
      for (let i = 1; i < headerLength; i++) {
        totalsColumnStyles[i] = {
          fillColor: [52, 73, 94],
          textColor: 255,
          fontStyle: 'bold',
          halign: 'center'
        };
      }
      
      doc.autoTable({
        startY: yPos,
        body: [totalsRow],
        theme: 'plain',
        styles: { 
          fontSize: 9, 
          cellPadding: 3,
          fillColor: [52, 73, 94], // Same blue as table headers (#34495e)
          textColor: 255, // White text
          fontStyle: 'bold',
          halign: 'center'
        },
        columnStyles: totalsColumnStyles,
        margin: { left: 15, right: 15 }
      });
      yPos = doc.lastAutoTable.finalY + 10;
      
      // Add signature boxes (Signed and Approved) if timesheet is submitted
      // Match the logic from submission receipt component
      if (timesheet.submitDate || timesheet.status !== 'OPEN') {
        yPos += 5;
        
        // Prepare signature data
        let userSignatureDataUrl = null;
        let approverSignatureDataUrl = null;
        
        // Load user signature if available
        if (user.signature) {
          const signatureTimeStamp = this.$rootScope.signatureTimeStamp || 0;
          const signatureUrl = this.$rootScope.apiHost + "/api/users/me/signature?" + signatureTimeStamp;
          userSignatureDataUrl = await this.loadImageAsDataUrl(signatureUrl);
        }
        
        // Load approver signature if approved/rejected and approver has signature
        if (timesheet.approver) {
          const approverId = timesheet.approver.id || timesheet.approver.userId;
          const hasApproverSignature = timesheet.approver.signature !== undefined && 
                                       timesheet.approver.signature !== null && 
                                       timesheet.approver.signature !== false;
          
          if (hasApproverSignature && approverId) {
            const approverSignatureTimeStamp = timesheet.approver.signatureTimeStamp || 0;
            const approverSignatureUrl = this.$rootScope.apiHost + "/api/users/" + approverId + "/signature?" + approverSignatureTimeStamp;
            approverSignatureDataUrl = await this.loadImageAsDataUrl(approverSignatureUrl);
          }
        }
        
        // Create signature boxes (side by side) - compact size
        const boxWidth = 50; // Reduced width for compact boxes
        const boxHeight = 28; // Reduced height
        const boxStartX = 15;
        const boxGap = 8;
        const boxY = yPos;
        
        // Signed Box
        const signedBoxX = boxStartX;
        doc.setFillColor(52, 152, 219); // Blue header (#3498db)
        doc.rect(signedBoxX, boxY, boxWidth, boxHeight, 'F');
        
        // Signed Box Header
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');
        doc.text('Signed', signedBoxX + boxWidth / 2, boxY + 4.5, { align: 'center' });
        
        // Signed Box Content (white background)
        doc.setFillColor(255, 255, 255);
        doc.rect(signedBoxX + 0.5, boxY + 5, boxWidth - 1, boxHeight - 5.5, 'F');
        
        let contentY = boxY + 8;
        const signatureImageHeight = 10; // Further reduced signature image size
        const signatureImageWidth = 40; // Further reduced signature image width
        
        // User signature image
        if (userSignatureDataUrl) {
          try {
            doc.addImage(userSignatureDataUrl, 'PNG', signedBoxX + 2, contentY, signatureImageWidth, signatureImageHeight);
            contentY += signatureImageHeight + 2;
          } catch (error) {
            console.warn('Could not add signature image to PDF:', error);
          }
        }
        
        // User name and date
        doc.setTextColor(0, 0, 0);
        doc.setFontSize(7);
        doc.setFont(undefined, 'bold');
        // Truncate name if too long for smaller box
        const displayUserName = userName.length > 15 ? userName.substring(0, 12) + '...' : userName;
        doc.text(displayUserName, signedBoxX + 2, contentY);
        contentY += 3.5;
        doc.setFont(undefined, 'normal');
        doc.setFontSize(6);
        // Handle case where submitDate might not exist (use empty string like submission receipt)
        const submittedDate = timesheet.submitDate 
          ? moment(timesheet.submitDate).format('MM/DD/YY')
          : '';
        if (submittedDate) {
          doc.text(submittedDate, signedBoxX + 2, contentY);
        }
        
        // Approved/Rejected Box
        const approvedBoxX = boxStartX + boxWidth + boxGap;
        let approvedHeaderColor = [62, 130, 31]; // Green-deep for approved (#3e821f)
        let approvedText = 'Approved';
        
        if (timesheet.status === 'REJECTED') {
          approvedHeaderColor = [231, 76, 60]; // Red for rejected (#e74c3c)
          approvedText = 'Rejected';
        } else if (!timesheet.approvedDate) {
          approvedHeaderColor = [243, 156, 18]; // Orange for pending (#f39c12)
          approvedText = 'Approved';
        }
        
        doc.setFillColor(approvedHeaderColor[0], approvedHeaderColor[1], approvedHeaderColor[2]);
        doc.rect(approvedBoxX, boxY, boxWidth, boxHeight, 'F');
        
        // Approved Box Header
        doc.setTextColor(255, 255, 255);
        doc.setFontSize(9);
        doc.setFont(undefined, 'bold');
        doc.text(approvedText, approvedBoxX + boxWidth / 2, boxY + 4.5, { align: 'center' });
        
        // Approved Box Content
        doc.setFillColor(255, 255, 255);
        doc.rect(approvedBoxX + 0.5, boxY + 5, boxWidth - 1, boxHeight - 5.5, 'F');
        
        contentY = boxY + 8;
        
        if (timesheet.status === 'APPROVED' && timesheet.approver && timesheet.approvedDate) {
          // Approved - show approver signature if available
          if (approverSignatureDataUrl) {
            try {
              doc.addImage(approverSignatureDataUrl, 'PNG', approvedBoxX + 2, contentY, signatureImageWidth, signatureImageHeight);
              contentY += signatureImageHeight + 2;
            } catch (error) {
              console.warn('Could not add approver signature image to PDF:', error);
            }
          }
          
          // Approver name and date
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(7);
          doc.setFont(undefined, 'bold');
          const approverName = `${timesheet.approver.firstName} ${timesheet.approver.lastName}`;
          // Truncate name if too long for smaller box
          const displayApproverName = approverName.length > 15 ? approverName.substring(0, 12) + '...' : approverName;
          doc.text(displayApproverName, approvedBoxX + 2, contentY);
          contentY += 3.5;
          doc.setFont(undefined, 'normal');
          doc.setFontSize(6);
          doc.text(moment(timesheet.approvedDate).format('MM/DD/YY'), approvedBoxX + 2, contentY);
        } else if (timesheet.status === 'REJECTED' && timesheet.approver) {
          // Rejected - show approver signature if available
          if (approverSignatureDataUrl) {
            try {
              doc.addImage(approverSignatureDataUrl, 'PNG', approvedBoxX + 2, contentY, signatureImageWidth, signatureImageHeight);
              contentY += signatureImageHeight + 2;
            } catch (error) {
              console.warn('Could not add approver signature image to PDF:', error);
            }
          }
          
          // Rejected by name and date
          doc.setTextColor(0, 0, 0);
          doc.setFontSize(7);
          doc.setFont(undefined, 'bold');
          const approverName = `${timesheet.approver.firstName} ${timesheet.approver.lastName}`;
          // Truncate name if too long for smaller box
          const displayApproverName = approverName.length > 15 ? approverName.substring(0, 12) + '...' : approverName;
          doc.text(displayApproverName, approvedBoxX + 2, contentY);
          contentY += 3.5;
          doc.setFont(undefined, 'normal');
          doc.setFontSize(6);
          if (timesheet.rejectDate) {
            doc.text(moment(timesheet.rejectDate).format('MM/DD/YY'), approvedBoxX + 2, contentY);
          } else if (timesheet.approvedDate) {
            doc.text(moment(timesheet.approvedDate).format('MM/DD/YY'), approvedBoxX + 2, contentY);
          }
        } else if (!timesheet.approvedDate && timesheet.status !== 'REJECTED') {
          // Pending approval
          doc.setTextColor(102, 102, 102);
          doc.setFontSize(6);
          doc.setFont(undefined, 'italic');
          doc.text('Pending', approvedBoxX + 2, contentY + 6);
        }
        
        yPos += boxHeight + 5;
      }
      
      // Footer
      const footerY = pageHeight - 10;
      doc.setFontSize(8);
      doc.setTextColor(128, 128, 128);
      doc.text(`Generated: ${moment().format('MMM DD, YYYY HH:mm')}`, pageWidth / 2, footerY, { align: 'center' });
      
      // Save the PDF with format: FirstName_LastName-MMDDYYYY_Timesheet
      const firstName = user.firstName || '';
      const lastName = user.lastName || '';
      const userFullName = `${firstName}_${lastName}`.replace(/\s+/g, '_'); // Replace spaces with underscores
      const endDateFormatted = moment(timesheet.endDate).format('MMDDYYYY');
      const fileName = `${userFullName}-${endDateFormatted}_Timesheet.pdf`;
      doc.save(fileName);
      
      this.toastr.success('Timesheet exported to PDF successfully.', 'Export Complete');
    } catch (error) {
      console.error('Error exporting PDF:', error);
      this.toastr.error('Failed to export timesheet to PDF.', 'Export Error');
    }
  }


}

export default TimesheetController;



// WEBPACK FOOTER //
// ./client/pages/timesheet/timesheet.controller.js